import {convertToCommonBackgroundVideo} from '../../../utils';
import React, {useState} from 'react';
import styled from 'styled-components';
import {ImageAndTextCardSmall} from '../cards/ImageAndTextCardSmall';
import {VideoGalleryVideoProps} from './VideoGallery';
import {useBreakpointDown} from 'epic-ue-theme';
import {VerticalSpacer} from '../spacer';
import {Button} from '../buttons/Button';

const Styled = styled.div`
    overflow-x: hidden;
    color: ${(p) => p.theme.ifLight(p, p.theme.palette.common.black, p.theme.palette.common.white)};
    cursor: pointer;

    .ue-image-and-text-card-small {
        padding-left: 16px;
        padding-right: 16px;
        div {
            margin: 0px;
        }
    }

    .selected {
        background-color: ${(p) =>
            p.theme.ifLight(p, p.theme.palette.neutral.pearl, p.theme.palette.neutral.steel)};
    }

    .see-all-button {
        margin-top: 16px;
        width: 100%;
        text-align: center;

        button.btn.btn-secondary {
            min-width: unset;
            font-size: 13px;
            line-height: 16px;
        }
    }
`;

export interface VideoGalleryListProps {
    videosList?: VideoGalleryVideoProps[];
    selectVideo?: (video: VideoGalleryVideoProps, i: number) => void;
    selectedVideoID?: number;
}

export const VideoGalleryList = ({
    videosList,
    selectVideo,
    selectedVideoID
}: VideoGalleryListProps): JSX.Element | null => {
    const [showAllVideosSM, setShowAllVideosSM] = useState(false);
    const isSm = useBreakpointDown('sm');

    const first3VideosList = videosList?.slice(0, 3);

    const displayVideosList = isSm && !showAllVideosSM ? first3VideosList : videosList;

    return (
        <Styled>
            <div className="video-gallery-videos-list">
                {displayVideosList?.map((video, i) => {
                    const backgroundImg = convertToCommonBackgroundVideo(video?.mainContentOptions);
                    return (
                        <div
                            role="button"
                            tabIndex={0}
                            key={i}
                            className={selectedVideoID === i ? 'selected' : ''}
                            onClick={() => {
                                selectVideo && selectVideo(video, i);
                            }}>
                            <VerticalSpacer variant="eyebrow" />
                            <ImageAndTextCardSmall
                                image={{
                                    src: backgroundImg?.image
                                }}
                                description={video?.descriptionTextBlocks?.headline}
                                eyebrow={video?.descriptionTextBlocks?.eyebrow?.text}
                            />
                            <VerticalSpacer variant="eyebrow" />
                        </div>
                    );
                })}
            </div>

            {isSm && !showAllVideosSM && (
                <div className="see-all-button">
                    <Button
                        type="secondary"
                        onClick={(e) => {
                            e.preventDefault();
                            setShowAllVideosSM(true);
                        }}>
                        {' '}
                        View All ({videosList?.length})
                    </Button>
                    <VerticalSpacer variant="custom" spacing={4} />
                </div>
            )}
        </Styled>
    );
};
